import { lazy } from "react";
import { registerSourceAuthSetup } from "./SourceAuthSetupRegistry";

export { getSourceAuthSetup, sourceOwnsAuthButtons, sourceAuthSetupUsesDialog } from "./SourceAuthSetupRegistry";
export type { SourceAuthSetupProps } from "./SourceAuthSetupRegistry";
export { SourceAuthSetupRenderer } from "./SourceAuthSetupRenderer";

// usesDialog=true: the Connect button triggers this component in a dialog rather than rendering it inline.
registerSourceAuthSetup("vsts", lazy(() => import("../../../auth-popup/vsts/VstsAuthSetup")), false, true);
registerSourceAuthSetup("zendesk", lazy(() => import("./ZendeskAuthSetup")), false, true);
registerSourceAuthSetup("monday", lazy(() => import("./MondayInstallInfo")), false, true);
